var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_933_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 2.44999C7.6 0.499988 4.45 0.499988 2.5 2.44999C0.9 4.04999 0.6 6.49999 1.7 8.44999L1 11L3.65 10.3C4.4 10.7 5.2 10.9 6 10.9C8.75 10.9 10.95 8.69999 10.95 5.94999C11 4.64999 10.45 3.39999 9.55 2.44999ZM8.2 9.44999C7.55 9.84999 6.8 10.1 6 10.1C5.25 10.1 4.55 9.89999 3.9 9.54999L3.75 9.44999L2.2 9.84999L2.6 8.34999L2.5 8.19999C1.3 6.19999 1.9 3.69999 3.85 2.44999C5.8 1.19999 8.3 1.84999 9.5 3.74999C10.7 5.69999 10.15 8.24999 8.2 9.44999Z",
    fill: "#116932",
    stroke: "#116932",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45 6.45C7.55 6.5 8.2 6.8 8.3 6.85L8.5 6.95C8.55 7.15 8.55 7.35 8.45 7.55C8.25 7.85 7.95 8.1 7.6 8.15C7.3 8.2 7.05 8.2 6.8 8.1C6.55 8.05 6.35 7.95 6.1 7.85C5.25 7.45 4.55 6.8 4 6C3.7 5.6 3.55 5.15 3.5 4.7C3.5 4.3 3.65 3.95 3.95 3.65C4 3.6 4.15 3.5 4.25 3.5H4.5C4.6 3.5 4.7 3.5 4.75 3.85C4.85 4.1 5.1 4.7 5.15 4.75C5.2 4.8 5.2 4.9 5.15 4.95C5.15 5 5.1 5.1 5.05 5.15C4.95 5.2 4.9 5.3 4.85 5.35C4.8 5.4 4.75 5.5 4.8 5.6C5 5.9 5.25 6.2 5.5 6.45C5.8 6.7 6.15 6.9 6.5 7.05C6.6 7.1 6.7 7.1 6.75 7C6.85 6.9 7.05 6.6 7.15 6.5C7.25 6.4 7.35 6.4 7.45 6.45Z",
    fill: "#116932"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_933_1694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c6de7ddad15f10c7d3cff37c2e4fdc38.svg";
export { ForwardRef as ReactComponent };